'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus from "./presto.-Site-Tables$-Group-Status.js";
import * as $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus$0024$0024anon$002421 from "./presto.-Site-Tables$-Group-Status$$anon$21.js";
import * as $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus$0024$0024anon$002422 from "./presto.-Site-Tables$-Group-Status$$anon$22.js";
import * as $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus$0024$0024anon$002423 from "./presto.-Site-Tables$-Group-Status$$anon$23.js";
var $p;
function $s_Lpresto_SiteTables$GroupStatus$__All__Lpresto_SiteTables$GroupStatus() {
  $m_Lpresto_SiteTables$GroupStatus$();
  return $t_Lpresto_SiteTables$GroupStatus$__All;
}
export { $s_Lpresto_SiteTables$GroupStatus$__All__Lpresto_SiteTables$GroupStatus as $s_Lpresto_SiteTables$GroupStatus$__All__Lpresto_SiteTables$GroupStatus };
function $s_Lpresto_SiteTables$GroupStatus$__Partial__Lpresto_SiteTables$GroupStatus() {
  $m_Lpresto_SiteTables$GroupStatus$();
  return $t_Lpresto_SiteTables$GroupStatus$__Partial;
}
export { $s_Lpresto_SiteTables$GroupStatus$__Partial__Lpresto_SiteTables$GroupStatus as $s_Lpresto_SiteTables$GroupStatus$__Partial__Lpresto_SiteTables$GroupStatus };
function $s_Lpresto_SiteTables$GroupStatus$__Pending__Lpresto_SiteTables$GroupStatus() {
  $m_Lpresto_SiteTables$GroupStatus$();
  return $t_Lpresto_SiteTables$GroupStatus$__Pending;
}
export { $s_Lpresto_SiteTables$GroupStatus$__Pending__Lpresto_SiteTables$GroupStatus as $s_Lpresto_SiteTables$GroupStatus$__Pending__Lpresto_SiteTables$GroupStatus };
/** @constructor */
function $c_Lpresto_SiteTables$GroupStatus$() {
  this.bxe = null;
  $n_Lpresto_SiteTables$GroupStatus$ = this;
  $t_Lpresto_SiteTables$GroupStatus$__All = new $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus$0024$0024anon$002421.$c_Lpresto_SiteTables$GroupStatus$$anon$21();
  $t_Lpresto_SiteTables$GroupStatus$__Partial = new $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus$0024$0024anon$002422.$c_Lpresto_SiteTables$GroupStatus$$anon$22();
  $t_Lpresto_SiteTables$GroupStatus$__Pending = new $j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus$0024$0024anon$002423.$c_Lpresto_SiteTables$GroupStatus$$anon$23();
  this.bxe = new ($j_presto$002e$002dSite$002dTables$0024$002dGroup$002dStatus.$d_Lpresto_SiteTables$GroupStatus.r().C)([$s_Lpresto_SiteTables$GroupStatus$__All__Lpresto_SiteTables$GroupStatus(), $s_Lpresto_SiteTables$GroupStatus$__Partial__Lpresto_SiteTables$GroupStatus(), $s_Lpresto_SiteTables$GroupStatus$__Pending__Lpresto_SiteTables$GroupStatus()]);
}
export { $c_Lpresto_SiteTables$GroupStatus$ as $c_Lpresto_SiteTables$GroupStatus$ };
$p = $c_Lpresto_SiteTables$GroupStatus$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SiteTables$GroupStatus$;
/** @constructor */
function $h_Lpresto_SiteTables$GroupStatus$() {
}
export { $h_Lpresto_SiteTables$GroupStatus$ as $h_Lpresto_SiteTables$GroupStatus$ };
$h_Lpresto_SiteTables$GroupStatus$.prototype = $p;
$p.cQD = (function() {
  return this.bxe.ar();
});
var $d_Lpresto_SiteTables$GroupStatus$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SiteTables$GroupStatus$, "presto.SiteTables$GroupStatus$", ({
  RI: 1,
  e: 1,
  H: 1
}));
export { $d_Lpresto_SiteTables$GroupStatus$ as $d_Lpresto_SiteTables$GroupStatus$ };
var $n_Lpresto_SiteTables$GroupStatus$;
function $m_Lpresto_SiteTables$GroupStatus$() {
  if ((!$n_Lpresto_SiteTables$GroupStatus$)) {
    $n_Lpresto_SiteTables$GroupStatus$ = new $c_Lpresto_SiteTables$GroupStatus$();
  }
  return $n_Lpresto_SiteTables$GroupStatus$;
}
export { $m_Lpresto_SiteTables$GroupStatus$ as $m_Lpresto_SiteTables$GroupStatus$ };
var $t_Lpresto_SiteTables$GroupStatus$__All = null;
function $u_Lpresto_SiteTables$GroupStatus$__All(x) {
  $t_Lpresto_SiteTables$GroupStatus$__All = x;
}
export { $t_Lpresto_SiteTables$GroupStatus$__All as $t_Lpresto_SiteTables$GroupStatus$__All, $u_Lpresto_SiteTables$GroupStatus$__All as $u_Lpresto_SiteTables$GroupStatus$__All };
var $t_Lpresto_SiteTables$GroupStatus$__Partial = null;
function $u_Lpresto_SiteTables$GroupStatus$__Partial(x) {
  $t_Lpresto_SiteTables$GroupStatus$__Partial = x;
}
export { $t_Lpresto_SiteTables$GroupStatus$__Partial as $t_Lpresto_SiteTables$GroupStatus$__Partial, $u_Lpresto_SiteTables$GroupStatus$__Partial as $u_Lpresto_SiteTables$GroupStatus$__Partial };
var $t_Lpresto_SiteTables$GroupStatus$__Pending = null;
function $u_Lpresto_SiteTables$GroupStatus$__Pending(x) {
  $t_Lpresto_SiteTables$GroupStatus$__Pending = x;
}
export { $t_Lpresto_SiteTables$GroupStatus$__Pending as $t_Lpresto_SiteTables$GroupStatus$__Pending, $u_Lpresto_SiteTables$GroupStatus$__Pending as $u_Lpresto_SiteTables$GroupStatus$__Pending };
//# sourceMappingURL=presto.-Site-Tables$-Group-Status$.js.map
